import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, Divider, FormControlLabel, Checkbox } from '@mui/material';
import { Card, Button } from '@totalsoft/rocket-ui';
import AssetHierarchyImportStatus from './AssetHierarchyImportStatus';
import * as constants from 'features/assetHierarchy/constants';
import { onCheckBoxChange } from 'utils/propertyChangeAdapters';
import SyncIcon from '@mui/icons-material/Sync';

const AssetHierarchyImportCard = ({
  onStartImport,
  onSelectProvider,
  selectedImportProviders,
  enabledImportProviders,
  running,
  importDisabled,
  importStatus
}) => {
  const { t } = useTranslation();
  const getStatus = providerCode => {
    const status = importStatus.filter(s => s.providerCode === providerCode);
    if (status.length === 0) return null;

    const sorted = status.sort((a, b) => (a.actionMoment > b.actionMoment ? -1 : 1));
    return sorted[0];
  };

  return (
    <Card icon={SyncIcon} iconColor='primary' title={t('AssetHierarchy.Import.Title')}>
      <Grid container spacing={1}>
        {enabledImportProviders.map(element => (
          <>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    color='primary'
                    name={`${element.name}ProviderSelection`}
                    checked={selectedImportProviders.some(x => x === element.name) || false}
                    disabled={running}
                    onChange={onCheckBoxChange(onSelectProvider(element.name))}
                  />
                }
                label={element.displayName ?? t(`AssetHierarchy.Import.${element.name}`)}
              />
            </Grid>
            <Grid item xs={12}>
              <AssetHierarchyImportStatus status={getStatus(constants[element.name])} />
            </Grid>
            <Grid item xs={12}>
              <Divider sx={{ m: 0 }} />
            </Grid>
          </>
        ))}

        <Grid item xs={12}>
          <Button color='primary' onClick={onStartImport} disabled={running || importDisabled}>
            {running ? t('AssetHierarchy.Import.Importing') + '...' : t('AssetHierarchy.Import.Import')}
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
};

AssetHierarchyImportCard.propTypes = {
  onStartImport: PropTypes.func.isRequired,
  onSelectProvider: PropTypes.func.isRequired,
  running: PropTypes.bool.isRequired,
  importStatus: PropTypes.array.isRequired,
  enabledImportProviders: PropTypes.array.isRequired,
  selectedImportProviders: PropTypes.array.isRequired,
  importDisabled: PropTypes.bool.isRequired
};

export default AssetHierarchyImportCard;
